let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gJTnu")).then(() => parcelRequire('dPsRS'));